export default () => ({
  items: null,
  current: undefined,
  nameToCreate: '',
  deletionPending: [],
  creationPending: false,
  updatePending: [],
  collectionName: null,
  color: 'grey'
})
